import React from 'react';
import PropTypes from 'prop-types';
import { getInputAndLabels } from '../helper';
/**
 * Компонент радио из кнопок в виде звездочек
 */
const RadioStars = ({
  id,
  title,
  answers,
  changeHandler
}) => /*#__PURE__*/React.createElement("div", {
  className: "radio-stars"
}, /*#__PURE__*/React.createElement("div", {
  id: id,
  className: "radio-stars__input"
}, getInputAndLabels({
  id,
  answers,
  changeHandler
})), /*#__PURE__*/React.createElement("div", null, title));
RadioStars.propTypes = {
  /** Идентификатор вопроса */id: PropTypes.number,
  answers: PropTypes.arrayOf(PropTypes.shape({
    /** Идентификатор */id: PropTypes.number,
    /** Заголовок */value: PropTypes.number
  })),
  /** Лейбл для звездочек */title: PropTypes.string,
  /** Изменение знаения инпута */changeHandler: PropTypes.func
};
export default RadioStars;